import { VizBlock } from './viz.types';
import { vizRegistry } from './vizRegistry';

interface VizRendererProps {
  block: VizBlock;
}

const VizRenderer = ({ block }: VizRendererProps) => {
  const Component = vizRegistry[block.kind];
  if (!Component) {
    console.warn('[rachel] viz kind sem componente registrado:', block.kind);
    return null;
  }
  return <Component block={block} />;
};

export default VizRenderer;
